import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import { SiaI18nDirective, SiaSizeDetectorService } from '@sia/shared';
import { DxSwitchModule } from 'devextreme-angular';
import { SiaGridConfigTab } from '../sia-grid-config-tab/sia-grid-config-tab.component';

@Component({
  selector: 'sia-grid-config-base',
  templateUrl: './sia-grid-config-base.component.html',
  styleUrls: ['./sia-grid-config-base.component.scss'],
  standalone: true,
  imports: [SiaI18nDirective, DxSwitchModule],
})
export class SiaGridConfigBaseComponent
  extends SiaGridConfigTab
  implements OnInit, OnDestroy
{
  private sizeDetector = inject(SiaSizeDetectorService);

  @HostListener('window:unload')
  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
